import CreditCardTableActions from '@/components/credit-cards/CreditCardTableActions.vue';
import DataTableColumnHeader from '@/components/datatable/DataTableColumnHeader.vue';
import type { CreditCard } from '@/types';
import type { ColumnDef } from '@tanstack/vue-table';
import { h } from 'vue';

export const columns: ColumnDef<CreditCard>[] = [
    {
        accessorKey: 'name',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'credit-cards.table.name',
            }),
    },
    {
        accessorKey: 'number',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'credit-cards.table.number',
            }),
    },
    {
        accessorKey: 'type_translated',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'credit-cards.table.type',
            }),
        filterFn: 'arrIncludesSome',
        meta: {
            filterType: 'checkbox',
        },
    },
    {
        accessorKey: 'assigned_names',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'credit-cards.table.assigned',
            }),
        filterFn: 'arrIncludesSome',
        meta: {
            filterType: 'checkbox',
        },
    },
    {
        id: 'actions',
        enableHiding: false,
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'tables.actions',
            }),
        cell: ({ row }) => {
            return h(CreditCardTableActions, {
                creditCard: row.original,
            });
        },
    },
];
